import script from "./addParkTour.vue?vue&type=script&setup=true&lang=js"
export * from "./addParkTour.vue?vue&type=script&setup=true&lang=js"

import "./addParkTour.vue?vue&type=style&index=0&id=18819a96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18819a96"]])

export default __exports__